export enum IdParenthood {
  Paternity = 1,
  Maternity = 2,
}
